import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c13125c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13125c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c13125c')) {
      api.createRecord('3c13125c', component.options)
    } else {
      api.reload('3c13125c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c13125c&scoped=true&", function () {
      api.rerender('3c13125c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hc/components/contractDialog/index.vue"
export default component.exports